import Cookies from 'js-cookie';

export const initialLandingPage = () => {
  const lucidChartSparkRegex = new RegExp(/^https?:\/\/(.*)(www\.)?lucid(chart|spark)/gi);
  const { origin, pathname } = window.location;
  const url = `${origin}${pathname}`;
  const cookie = Cookies.get('initialLandingPage');
  let sessionInitialLandingPage = '';

  if (!window.sessionStorage.initialLandingPage && !cookie) {
    Cookies.set('initialLandingPage', url);
    return window.sessionStorage.initialLandingPage = url;
  }

  if (window.sessionStorage.initialLandingPage) {
    sessionInitialLandingPage = url;
  }

  if ((url.match(lucidChartSparkRegex) && cookie) && !sessionInitialLandingPage) {
    Cookies.set('initialLandingPage', url);
    return window.sessionStorage.initialLandingPage = url;
  }
};
